/**************************************************
 * Nombre:       Apartado_Portada_Dos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Box, Grid} from "@mui/material";
import imagen from '../../Recursos/Temporales/img_portada.png'
import logo from '../../Recursos/logo.svg'
import logo_redondo from '../../Recursos/logo_redondo.svg'
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";

const Apartado_Portada_Dos = ({item}) => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}}
                      sx={{justifyContent: 'flex-start', p: sCell ? 0 : 4, mt: sCell ? 3 : 1, zIndex: 2}}>
                    <img src={sCell ? logo_redondo : logo} width={sCell ? 30 : 250} height={'auto'}/>
                </Grid>

            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: sCell ? -7 : 0}}>


                <Box
                    size={{xs: 12, sm: 12, md: 8}}
                    sx={{
                        backgroundImage: `linear-gradient(180deg, rgba(0, 0, 0, 0.00) 23.31%, #230E47 89.53%), url(${item.img})`,
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: 'cover',
                        backgroundPosition: 'center center',
                        height: 320,
                        width: sCell ? '100%' : 320,
                        borderRadius: sCell ? 0 : '50%',
                        zIndex: 1
                    }}
                />


            </Grid>

        </Grid>
    )

}
export default Apartado_Portada_Dos  